import { useRef } from 'react';

export const useTour = () => {
  const approveRequestRef = useRef(null);
  const rejectRequestRef = useRef(null);

  const steps = [
    {
      title: 'Страница добавления пользователей',
      description:
        'Добро пожаловать в раздел «Добавление пользователей» — здесь вы обрабатываете входящие запросы на регистрацию новых пользователей в системе. Удобное подтверждение и мгновенное управление.',
      target: null,
    },
    {
      title: 'Таблица запросов',
      description:
        'В этой таблице отображаются все заявки на добавление с данными пользователей, ожидающих вашего подтверждения.',
      target: null,
    },
    {
      title: 'Принять запрос',
      description:
        'Подтвердите запрос, чтобы добавить нового пользователя в систему. После подтверждения пользователь появится в основном списке.',
      target: () => approveRequestRef.current,
    },
    {
      title: 'Отклонить запрос',
      description:
        'Отклоните запрос, если добавление пользователя не требуется. После отклонения заявка исчезнет из таблицы.',
      target: () => rejectRequestRef.current,
    },
  ];

  return {
    approveRequestRef,
    rejectRequestRef,
    steps,
  };
};
